import Button from "components/base/button/Button";
import { FC, ReactElement, useCallback, useContext } from "react";
import classNames from "classnames";
import { HoursRange } from "@finbackoffice/websocket-client";
import { PrematchContext } from "contexts";
import styles from "./prematch-time-filter-tabs.module.sass";

type TimeFilterData = {
    label: string | ReactElement<any>;
    value: HoursRange;
};

const timeFilterData: TimeFilterData[] = [
    {
        label: "All",
        value: HoursRange.ALL,
    },
    {
        label: "24H",
        value: HoursRange.TWENTY_FOUR,
    },
    {
        label: "12H",
        value: HoursRange.TWELVE,
    },
    {
        label: "6H",
        value: HoursRange.SIX,
    },
    {
        label: "1H",
        value: HoursRange.ONE,
    },
];

type Props = {
    onSelect?: () => void;
};

const PrematchTimeFilterTabs: FC<Props> = ({ onSelect }) => {
    const { setHoursRange, hoursRange } = useContext(PrematchContext);

    const handleSelectFilter = useCallback(
        (value: HoursRange) => {
            if (value !== hoursRange) {
                setHoursRange(value);
            }

            typeof onSelect === "function" && onSelect();
        },
        [hoursRange, onSelect, setHoursRange],
    );

    return (
        <div className={styles.timeFilters}>
            {timeFilterData.map(({ label, value }) => (
                <Button
                    key={value}
                    type="button"
                    variant="custom"
                    className={classNames(styles.timefilter, {
                        [styles.active]: value === hoursRange,
                    })}
                    onClick={() => handleSelectFilter(value)}>
                    {label}
                </Button>
            ))}
        </div>
    );
};

export default PrematchTimeFilterTabs;
